import { connect } from 'react-redux';
import { passwordChange, passwordBlur } from './actions';
import OpenWidget from '../inputs/OpenWidget';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    isValid: question.isValid,
    value: question.value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => dispatch(passwordChange(e.target.value, ownProps.questionId)),
  onBlur: () => dispatch(passwordBlur(ownProps.questionId)),
});

const Input = connect(mapStateToProps, mapDispatchToProps)(OpenWidget);

export default Input;
